import React from 'react';
import { Popover } from "@progress/kendo-react-tooltip";

export function MaterialDetails(props) {
    const [isCopied, setIsCopied] = React.useState(false);
    const [copyText, setCopyText] = React.useState("");
    const popoverAnchor = React.useRef(null);
    const [showCopiedPopover, setShowCopiedPopover] = React.useState(false);
    const allSynsLink = <a className="gridLink" onClick={props.showSynonymsModal} onKeyDown={(e) => { if (e.code === "Enter") props.showSynonymsModal(); }}>{props.localizations.ShowAll}</a>;

    async function copyTextToClipboard(text) {
        if ("clipboard" in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand("copy", true, text);
        }
    }

    const handleCopyClick = (copiedText) => {
        setShowCopiedPopover(!showCopiedPopover);
        copyTextToClipboard(copiedText)
            .then(() => {
                setCopyText(copiedText);
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                    setShowCopiedPopover(false);
                }, 3000);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return <div className="row">
        <div className="col-4" >
            <p style={{ color: "#2b2d42", fontFamily: "Inter" }}>
                <strong>{props.localizations.ChemicalName}:</strong>{" "}
                <span className="selectable">{props.materialData.chemicalName}</span>
            </p>
        </div>
        <div className="col-4">
            <p style={{ color: "#2b2d42", fontFamily: "Inter" }}>
                <strong>{props.localizations.Synonyms}:</strong>{" "}
                <span className="selectable">{props.materialData.synonymsString} {props.materialData.synonymsString != null && props.materialData.synonymsString.length > 0 ? allSynsLink : ""}</span>
            </p>
        </div>
        <div className="col-4">
            <p style={{ color: "#2b2d42", width: "fit-content", }} >
                <strong>{props.localizations.MaterialId}:</strong>{" "}
                <input type="hidden" value={copyText}></input>

                {!isCopied && (
                    <i className="icon-ui-general-page"
                        onClick={(e) => handleCopyClick(props.materialData.materialId)}
                        onKeyDown={(e) => { if (e.keyCode === 13) handleCopyClick(props.materialData.materialId); }}
                        style={{ background: "#009BDE" }}
                    ></i>
                )}
                {isCopied && <i className="icon-ui-general-check" style={{ background: "#33BB44" }}></i>}
                <span
                    className="selectable material-id"
                    onClick={(e) => handleCopyClick(props.materialData.materialId)}
                    onKeyDown={(e) => { if (e.code === "Enter") handleCopyClick(props.materialData.materialId); }}
                >
                    {props.materialData.materialId}
                </span>
            </p>
        </div>
        {(props.customer.columns && props.customer.columns.materialColumns) && props.customer.columns.materialColumns.map(
            (column, idx) => {
                // Suppress a field here if it isn't included, or if it is already promoted to the header.
                let inHeader = (props.headerFields || []).some(hf => hf.field === column.field);
                if (inHeader || !column.show)
                    return "";
                else
                    return (
                        <div className="col-4" key={idx} >
                            <p style={{ color: "#2b2d42", fontFamily: "Inter" }}>
                                <strong>{column.Title}:</strong>{" "}
                                {column.IsList === "true"
                                    ? <span className="selectable" dangerouslySetInnerHTML={{ __html: props.materialData[column.field + "Display"] }}></span>
                                    : <span className="selectable">{props.materialData[column.field]}</span>}
                            </p>
                        </div>);
            }
        )}

        <Popover
            show={showCopiedPopover}
            anchor={popoverAnchor.current}
            position="top"
        >
            Copied!
        </Popover>
    </div>;
}